// SEO metadata per page for ALLCOM.CL
// Each page has: title, description, keywords, og:image

const BASE = 'https://allcom.cl';

const seoData = {
  '/': {
    title: 'ALLCOM | Inteligencia Artificial Empresas Chile · Automatización Retail · Agentes Autónomos',
    description: 'ALLCOM es líder en Inteligencia Artificial para empresas en Chile: agentes autónomos, IA Advisor, automatización retail, dashboards ejecutivos, self-checkout y operación 24/7. Hardware + software + IA en un solo proveedor.',
    keywords: 'Inteligencia Artificial Empresas Chile, Automatización Retail, Agentes Autónomos, IA Advisor, ALLCOM, autoservicio chile, self-checkout, retail tech, kioscos, POS, IA retail',
  },
  '/ia-soluciones': {
    title: 'IA Hub — Inteligencia Artificial Empresas Chile | ALLCOM',
    description: 'Centro neurálgico de IA de ALLCOM: ROI Calculator, OpenClaw, agentes autónomos, dashboards ejecutivos y Kian Daily. Inteligencia artificial aplicada a empresas en Chile.',
    keywords: 'Inteligencia Artificial Empresas Chile, Automatización Retail, Agentes Autónomos, IA Advisor, OpenClaw, dashboards IA, Kian Daily, IA Hub',
  },
  '/soluciones/visual-experience': {
    title: 'AVX · ALLCOM Visual Experience — LED Premium, Digital Signage Inteligente | Chile',
    description: 'AVX es la división de tecnología visual de ALLCOM: pantallas LED de alta fidelidad (Digital Shelf Strips, Rental Elite P2.6 4K HDR, Transparent LED arquitectónico) integradas con software, analítica e IA. Retail, eventos corporativos y arquitectura premium en Chile.',
    keywords: 'AVX chile, ALLCOM Visual Experience, pantallas LED chile, digital shelf strips, LED rental P2.6, transparent LED, digital signage premium, fachadas digitales, LED arquitectónico, eventos corporativos LED',
  },
  '/soluciones': {
    title: 'Soluciones Integrales de Tecnología | ALLCOM Chile',
    description: 'Autoservicio, ESL, cartelería digital, gestión de filas, aeropuertos y pesaje. Hardware + software + integración + operación 24/7 en un solo proveedor.',
    keywords: 'soluciones tecnológicas retail, autoservicio, ESL, cartelería digital, gestión de filas',
  },
  '/soluciones/autoservicio-self-checkout': {
    title: 'Autoservicio & Self-Checkout en Chile | ALLCOM',
    description: 'Kioscos self-checkout integrados con tu POS, soporte 24/7 y arriendo sin CAPEX inicial. Reduce filas, aumenta ventas. Líder en autoservicio en Chile.',
    keywords: 'self checkout chile, kioscos autoservicio, autoservicio supermercado, self-checkout retail',
  },
  '/soluciones/esl-precios-digitales': {
    title: 'ESL / Precios Digitales — Etiquetas Electrónicas SOLUM | ALLCOM',
    description: 'Etiquetas electrónicas de precios SOLUM con integración POS/ERP. Actualiza precios en segundos, cero errores en sala. Líder ESL en Chile.',
    keywords: 'ESL chile, etiquetas electrónicas precios, SOLUM, precios digitales retail',
  },
  '/soluciones/carteleria-digital': {
    title: 'Cartelería Digital para Retail | ALLCOM Chile',
    description: 'Digital signage premium con gestión centralizada, contenido dinámico y analítica. Pantallas profesionales para retail, banca y aeropuertos.',
    keywords: 'cartelería digital chile, digital signage, pantallas retail, señalización digital',
  },
  '/soluciones/maquinas-vending': {
    title: 'Máquinas Vending Inteligentes con IoT | ALLCOM Chile',
    description: 'Máquinas vending inteligentes con telemetría IoT, pagos contactless, monitoreo remoto y analytics de consumo. Operación autónoma 24/7 en Chile.',
    keywords: 'máquinas vending chile, vending inteligente, vending IoT, máquinas expendedoras',
  },
  '/soluciones/turnomaticos-gestion-filas': {
    title: 'Turnomáticos y Gestión de Filas Inteligente | ALLCOM Chile',
    description: 'Kioscos de turnos, pantallas de llamado, turno virtual y analytics de flujo. Gestión inteligente de filas para banca, salud, retail y gobierno en Chile.',
    keywords: 'turnomáticos chile, gestión de filas, sistema de turnos, turnero digital, filas inteligentes',
  },
  '/soluciones/gestion-filas': {
    title: 'Gestión de Filas y Turnos Inteligentes | ALLCOM Chile',
    description: 'Sistema de gestión de turnos con kioscos, pantallas y analytics en tiempo real. Reduce tiempos de espera en retail, banca y salud.',
    keywords: 'gestión de filas chile, sistema de turnos, turnero digital, filas inteligentes',
  },
  '/soluciones/balanzas-pesaje-comercial': {
    title: 'Balanzas de Pesaje Comercial e Industrial | ALLCOM Chile',
    description: 'Balanzas comerciales e industriales Marques con IA, integración ERP, etiquetado automático y soporte 24/7. Supermercados, minimarkets, carnicerías y plantas industriales.',
    keywords: 'balanzas comerciales chile, balanzas supermercado, pesaje industrial, Marques balanzas, balanzas con IA',
  },
  '/soluciones/aeropuertos': {
    title: 'Soluciones para Aeropuertos — Charging, Kioscos, Medición | ALLCOM',
    description: 'Estaciones de carga, medidores de equipaje y kioscos interactivos para aeropuertos. Airport charging y DOOH con monitoreo 24/7.',
    keywords: 'aeropuertos chile, airport charging, estaciones carga aeropuerto, kioscos aeropuerto',
  },
  '/soluciones/puntos-de-venta-pos': {
    title: 'Puntos de Venta POS Profesionales | ALLCOM Chile',
    description: 'Terminales POS profesionales All-in-One para retail, HORECA, salud y servicios. Windows, Android, Linux. Marcas: Poslab, Wintec, Toshiba, NCR, iMin, Nebula. Soporte 24/7.',
    keywords: 'POS chile, punto de venta, terminal POS, POS all-in-one, POS android, POS retail',
  },
  '/soluciones/pesaje-industrial': {
    title: 'Pesaje Industrial y Comercial | Balanzas Marques — ALLCOM Chile',
    description: 'Balanzas industriales y comerciales Marques con integración ERP/WMS. Certificación SERNAC y soporte técnico nacional.',
    keywords: 'pesaje industrial chile, balanzas comerciales, Marques, pesaje retail',
  },
  '/soluciones/portillones-automaticos': {
    title: 'Portillones Automáticos para Retail | ALLCOM Chile',
    description: 'Portillones automáticos con sensores, QR de boletas y sistemas inteligentes para supermercados y tiendas. Control de acceso retail.',
    keywords: 'portillones automáticos chile, control acceso retail, portillones supermercado',
  },
  '/hardware': {
    title: 'Catálogo Hardware Premium para Retail | ALLCOM Chile',
    description: 'Kioscos, POS, balanzas, ESL, cartelería, PDAs, servidores y más. 14 categorías de hardware con las mejores marcas: Wintec, iMin, SOLUM, Zebra, Lenovo.',
    keywords: 'hardware retail chile, POS chile, kioscos, balanzas comerciales, ESL',
  },
  '/software': {
    title: 'Plataforma Software ALLCOM — Control Panel, Analytics, CEO Cockpit™',
    description: 'Software propio para gestión de flota, analytics, dashboards ejecutivos y sincronización. Control Panel, CEO Cockpit™, C-Suite™, Synkro™.',
    keywords: 'software retail chile, dashboard retail, CEO cockpit, analytics operación',
  },
  '/ia/allcom-ia': {
    title: 'ALLCOM IA Studio — Inteligencia Artificial Aplicada al Negocio',
    description: 'Configuramos agentes IA, diseñamos prompts, automatizamos procesos. Prueba conceptual en 48h, mockup en 4 días, implementación en 30 días. Consultoría IA en Chile.',
    keywords: 'inteligencia artificial chile, agentes IA, consultoría IA, automatización IA retail',
  },
  '/ia/dashboards-ejecutivos': {
    title: 'Dashboards Ejecutivos con IA | ALLCOM Chile',
    description: 'Dashboards con inteligencia artificial para CEO, COO y C-Level. KPIs en tiempo real, predicciones y recomendaciones automáticas.',
    keywords: 'dashboards ejecutivos IA, KPIs retail, dashboard CEO, analytics inteligente',
  },
  '/ia/agentes-ia': {
    title: 'Agentes de IA Personalizados | ALLCOM Chile',
    description: 'Agentes IA modulares y escalables para tareas de operación en sucursales y locales comerciales. Sin orquestadores, fáciles de usar.',
    keywords: 'agentes IA chile, automatización operaciones, IA para retail, agentes inteligentes',
  },
  '/ia/openclaw': {
    title: 'OpenClaw / Claude Cowork — Agentes Autónomos de IA | ALLCOM Chile',
    description: 'ALLCOM es implementador oficial de OpenClaw en Chile. Data lakes inteligentes, agentes autónomos y Claude Cowork para productividad empresarial.',
    keywords: 'OpenClaw chile, Claude Cowork, data lake, agente autónomo IA, implementador OpenClaw',
  },
  '/servicios': {
    title: 'Servicios de Tecnología — Soporte 24/7, Arriendo, Implementación | ALLCOM',
    description: 'Soporte 24/7, programa piloto, arriendo tecnológico, implementación, despliegues masivos y renovaciones. Servicios completos para tu operación.',
    keywords: 'soporte técnico 24/7 chile, arriendo tecnológico, implementación retail, despliegue masivo',
  },
  '/servicios/soporte-24-7': {
    title: 'Soporte Técnico 24/7 con SLA Garantizado | ALLCOM Chile',
    description: 'Mesa de ayuda 24/7, técnicos en terreno nacional, repuestos en stock, monitoreo remoto proactivo. SLA con tiempos de respuesta garantizados.',
    keywords: 'soporte técnico 24/7 chile, SLA, soporte terreno, monitoreo remoto retail',
  },
  '/servicios/piloto': {
    title: 'Programa Piloto 30 Días — Sin Riesgo | ALLCOM Chile',
    description: 'Prueba nuestras soluciones en tu operación real. 30 días con equipos reales, soporte completo y reporte ejecutivo de ROI. Sin compromiso.',
    keywords: 'piloto tecnológico chile, prueba gratis retail, demo self-checkout',
  },
  '/servicios/arriendo-leasing': {
    title: 'Arriendo & Leasing Tecnológico (OPEX) | ALLCOM Chile',
    description: 'Hardware + software + operación en una cuota mensual. Cero CAPEX. Ideal para enterprise y sector público. Arriendo de kioscos, POS y tecnología.',
    keywords: 'arriendo tecnológico chile, leasing equipos, OPEX tecnología, arriendo kioscos',
  },
  '/servicios/renovaciones-tecnologicas': {
    title: 'Renovaciones Tecnológicas Masivas | ALLCOM Chile',
    description: 'Bodegas, logística, seguros, staging, técnicos calificados. Renovaciones masivas de equipamiento con cartas Gantt y plazos garantizados.',
    keywords: 'renovación tecnológica chile, refresh tecnológico retail, despliegue masivo',
  },
  '/servicios/obras-civiles': {
    title: 'Obras Civiles para Integración Tecnológica | ALLCOM Chile',
    description: 'Obras civiles en locales comerciales: instalaciones eléctricas, cableado, montaje y terminaciones para integrar tecnología retail.',
    keywords: 'obras civiles retail chile, instalación tecnológica, cableado estructurado',
  },
  '/casos': {
    title: 'Casos de Éxito — Resultados Reales | ALLCOM Chile',
    description: 'Proyectos reales con métricas verificables. Conoce cómo ALLCOM ha transformado operaciones en retail, banca y aeropuertos en Chile.',
    keywords: 'casos de éxito retail chile, proyectos tecnología, resultados ALLCOM',
  },
  '/ceocockpit': {
    title: 'CEO Cockpit™ Demo | ALLCOM — Operación y Resultados en Tiempo Real',
    description: 'Dashboard ejecutivo demo: estado de dispositivos, ventas, merma, uptime, alertas y métricas operativas por industria.',
    keywords: 'CEO cockpit, dashboard ejecutivo, KPIs operación, demo retail',
  },
  '/csuite': {
    title: 'C-Suite Dashboard™ Demo | ALLCOM — Operación, TI, Finanzas y Experiencia',
    description: 'Dashboard demo por área: operaciones, TI, finanzas y experiencia del cliente con KPIs, alertas y tendencias por industria.',
    keywords: 'C-Suite dashboard, dashboard por área, KPIs finanzas, dashboard TI',
  },
  '/empresa/nosotros': {
    title: 'Nosotros — Tecnología, Inteligencia y Visión | ALLCOM Chile',
    description: 'ALLCOM: +21 años de innovación, +300 empresas atendidas, +10.000 dispositivos desplegados. Pensamos el futuro, diseñamos con inteligencia, ejecutamos con solidez.',
    keywords: 'ALLCOM chile, empresa tecnología retail, quiénes somos ALLCOM',
  },
  '/empresa/equipo': {
    title: 'Nuestro Equipo — El Crew de ALLCOM',
    description: 'Ingenieros, técnicos y líderes comprometidos. Mario Pino Corona (CEO), José de Amorin (CIO), Rodrigo Mancilla (Líder Desarrollo).',
    keywords: 'equipo ALLCOM, Mario Pino Corona, equipo retail tech chile',
  },
  '/empresa/historia': {
    title: 'Nuestra Historia — De una Bodega a Liderar el Retail-Tech | ALLCOM',
    description: 'ALLCOM nació en 2003 en una oficina de 6m². Hoy lideramos la tecnología retail en Chile con +500 proyectos y presencia en 3 países.',
    keywords: 'historia ALLCOM, fundación ALLCOM, Mario Pino Corona, retail tech chile historia',
  },
  '/empresa/partners': {
    title: 'Partners Tecnológicos — Wintec, iMin, SOLUM, Justo, Zebra | ALLCOM',
    description: 'Representantes autorizados de las principales marcas mundiales de tecnología retail. Wintec, iMin, SOLUM, Justo, Epson, Lenovo, Zebra.',
    keywords: 'partners ALLCOM, Wintec chile, iMin chile, SOLUM chile, Justo POS',
  },
  '/empresa/informacion-corporativa': {
    title: 'Información Corporativa — Gobierno y Compliance | ALLCOM S.A.',
    description: 'Información accionaria, canal de denuncias, marcas registradas, compliance, gobernanza y protección de datos de ALLCOM S.A.',
    keywords: 'ALLCOM S.A., gobierno corporativo, compliance chile, información societaria',
  },
  '/contacto': {
    title: 'Contacto — Cotizar & Agendar Demo | ALLCOM Chile',
    description: 'Contacta a ALLCOM para cotizar soluciones de autoservicio, hardware, software e IA. Respuesta en menos de 24 horas. WhatsApp: +56 9 7529 4340.',
    keywords: 'contacto ALLCOM, cotizar autoservicio chile, agendar demo retail',
  },
  '/novedades': {
    title: 'Novedades & Releases — Lo último de la plataforma ALLCOM',
    description: 'Cambios y releases recientes de la plataforma ALLCOM: carrito B2B, vertical aeropuertos, IA aplicada, SEO técnico, refinamiento UX. Construido sin agencias intermedias.',
    keywords: 'novedades allcom, releases, changelog, lo nuevo retail tech chile, plataforma B2B',
  },
};

// Get SEO data for a path
export const getSEO = (pathname) => {
  // Exact match first
  if (seoData[pathname]) return seoData[pathname];
  
  // Pattern matches
  if (pathname.startsWith('/soluciones/')) return { title: 'Soluciones | ALLCOM Chile', description: 'Soluciones integrales de tecnología para retail, banca, salud y minería. ALLCOM Chile.', keywords: 'soluciones retail chile' };
  if (pathname.startsWith('/servicios/')) return { title: 'Servicios | ALLCOM Chile', description: 'Servicios tecnológicos: soporte 24/7, arriendo, implementación y despliegues masivos. ALLCOM Chile.', keywords: 'servicios tecnología chile' };
  if (pathname.startsWith('/hardware/')) return { title: 'Hardware | ALLCOM Chile', description: 'Catálogo de hardware premium para retail: kioscos, POS, balanzas, ESL, servidores. ALLCOM Chile.', keywords: 'hardware retail chile' };
  if (pathname.startsWith('/software/')) return { title: 'Software | ALLCOM Chile', description: 'Plataforma de software propio para gestión, analytics y dashboards ejecutivos. ALLCOM Chile.', keywords: 'software retail chile' };
  if (pathname.startsWith('/casos/')) return { title: 'Caso de Éxito | ALLCOM Chile', description: 'Caso de éxito con métricas reales. Conoce cómo ALLCOM transformó esta operación.', keywords: 'caso éxito retail chile' };
  
  // Default
  return { title: 'ALLCOM | Soluciones Inteligentes', description: 'ALLCOM — Soluciones inteligentes para empresas que no se detienen. Tecnología, IA y operación 24/7 en Chile.', keywords: 'ALLCOM chile' };
};

export default seoData;
